import React from 'react';

import CSSModule from 'react-css-modules';
import { useNavigate } from 'react-router-dom';
import styles from './PrivacyPolicy.module.scss';

const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL;

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div styleName="page">
      <div styleName="toolbar">
        <button type="button" styleName="back" onClick={() => navigate('/my-account')}>
          ← Back to account
        </button>
      </div>
      <iframe title="Privacy Policy" src={PRIVACY_POLICY_URL} styleName="frame" />
    </div>
  );
};

export default CSSModule(PrivacyPolicy, styles, { allowMultiple: true });